import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";

const FloorWiseFireProtectionEquipmentView = ({
  floorWiseFireProtectionEquipments,
  isExpandable = true,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Floors",
        key: "floors",
        renderField: (floors) =>
          floors.length ? floors.map(({ name }) => name).join(", ") : "N/A",
      },
      {
        name: "Hydrant Valve",
        key: "hydrantValve",
        isRequired: true,
      },
      {
        name: "Hose Box",
        key: "hoseBox",
        isRequired: true,
      },
      {
        name: "Hose Pipe",
        key: "hosePipe",
        isRequired: true,
      },
      {
        name: "Branch Pipe",
        key: "branchPipe",
        isRequired: true,
      },
      {
        name: "Hose Reel Hose",
        key: "hoseReel",
        isRequired: true,
      },

      {
        name: "Pump On/Off Switch",
        key: "pumpOnOffSwitch",
        isRequired: true,
      },
      {
        name: "Signages",
        key: "signages",
        isRequired: true,
      },
      {
        name: "Fire Extinguishers",
        key: "fireExtinguishers",
        isRequired: true,
      },
      {
        name: "Sprinklers",
        key: "sprinklers",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse
        title="Floor Wise Fire Protection Equipment"
        isExpandable={isExpandable}
      >
        {floorWiseFireProtectionEquipments.map(
          (fireProtectionEquipment, index) => (
            <Fragment key={fireProtectionEquipment.id}>
              <Row className="d-flex  mb-2">
                <label className="fw-semibold">
                  {t("Fire Protection Equipment") + " : " + (index + 1)}
                </label>
                {fields.map(({ name, key, isRequired, renderField }) => {
                  const value = get(fireProtectionEquipment, key, "");

                  return (
                    <Col key={key} lg={6} className="mb-1">
                      <Row>
                        <Col md={5}>{t(name)}:</Col>
                        <Col
                          md={7}
                          className="fw-semibold"
                          style={{ wordBreak: "break-word" }}
                        >
                          {renderField
                            ? renderField(value)
                            : get(fireProtectionEquipment, key, null) ??
                              (isRequired ? "-" : "N/A")}
                        </Col>
                      </Row>
                    </Col>
                  );
                })}
              </Row>
            </Fragment>
          )
        )}
      </Collapse>
    </>
  );
};

FloorWiseFireProtectionEquipmentView.propTypes = {
  floorWiseFireProtectionEquipments: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(FloorWiseFireProtectionEquipmentView);
